import { render } from "./vyingbiconsume.vue?vue&type=template&id=aef10b10&scoped=true"
import script from "./vyingbiconsume.vue?vue&type=script&lang=js"
export * from "./vyingbiconsume.vue?vue&type=script&lang=js"

import "./vyingbiconsume.vue?vue&type=style&index=0&id=aef10b10&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef10b10"]])

export default __exports__